import React from "react";
import * as properties from '../../elementsPropertiesItems';
import { isSet } from '../../../../Utils/CommonFunctions';

const PaperSize = (props)=>{
    const {path,keyParam,elementData} = props;
    let paperSizeValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'100%':'100%';

    const changeHandler = (e) => {
        const {value} = e.target;        
        props.changeHandler(path,keyParam,value)
    }

    return(
        <div className="w-100">
     		<select className="form-control input-border-bottom1" onChange={e=>changeHandler(e)}>
                {
                    properties.PaperSizeTypes.map((item,ind)=>{
                        let isSelected = '';
                        if(item.value === paperSizeValue){
                           isSelected = 'selected';
                        }
                        return(
                            <option selected={isSelected} value={item.value}> {item.label} </option>    
                        )
                    })
                }        		
     		</select>
  		</div>
    )
}

PaperSize.defaultProps = {
    fontWeightValue: '100%',    
};

export default PaperSize;